import { jsx as r } from "react/jsx-runtime";
import { createStyles as S, NativeSelect as p } from "@mantine/core";
import { useMemo as u, useCallback as f } from "react";
import "../ProductTileSkeleton.js";
import { IconChevronDown as v } from "../../Icon/icons/ChevronDown.js";
const g = S(() => ({
  icon: {
    pointerEvents: "none"
  }
})), I = ({ activeSku: a, onSkuChange: c, skus: t }) => {
  const { classes: s } = g(), l = u(() => t.map(({ badge: e, displayName: o, sku: n }) => ({
    label: e == "sale" ? `${o} - On Sale` : o,
    value: n
  })), [t]), i = f((e) => {
    const { value: o } = e.target, { sku: n } = t.find(({ sku: m }) => m === o) || {};
    n && c({ skuId: n });
  }, [c, t]);
  return r(p, { data: l, classNames: {
    rightSection: s.icon
  }, value: a, onChange: (e) => i(e), rightSection: r(v, { size: 16 }), mb: "lg" });
};
export {
  I as SkuSelect
};
